module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rewards.items !== null) ? _c('div', {
    staticClass: "o-rewards__cardgroup"
  }, [_vm._l((_vm.rewards.items), function(reward) {
    return _c('section', {
      staticClass: "c-card c-card--reward qa-card"
    }, [_c('router-link', {
      staticClass: "c-card--reward__link",
      attrs: {
        "to": _vm.getRouterLink(reward)
      }
    }, [_c('div', {
      staticClass: "c-card--reward__thumbnail"
    }, [(_vm.getImgUrl(reward)) ? _c('img', {
      staticClass: "c-card--reward__thumbnail__img",
      attrs: {
        "src": _vm.getImgUrl(reward)
      }
    }) : _c('img', {
      staticClass: "c-card--reward__thumbnail__placeholder",
      attrs: {
        "src": "/img/thm350.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-card--reward__info"
    }, [_c('h2', {
      staticClass: "c-card--reward__info__name t-link"
    }, [_vm._v("\n          " + _vm._s(reward.name) + "\n        ")]), _vm._v(" "), (reward.supplier_items) ? _c('div', {
      staticClass: "c-card--reward__info__cost"
    }, [_c('i', {
      staticClass: "fa fa-star t-points-icon"
    }), _vm._v(" "), (_vm.rewardHasRange(reward)) ? _c('span', [_vm._v("From")]) : _vm._e(), _vm._v(" "), _c('vue-numeric', {
      attrs: {
        "separator": ",",
        "read-only": true,
        "value": _vm.getRewardPrice(reward)
      }
    })], 1) : _vm._e()])])], 1)
  }), _vm._v(" "), (_vm.rewards.items !== null && Object.keys(_vm.rewards.items).length === 0) ? _c('section', {
    staticClass: "c-no-results qa-no-results"
  }, [_c('p', {
    staticClass: "c-no-results__p t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_rewards_list.no_rewards')))])]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-421643ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/RewardsList.vue
// module id = 529
// module chunks = 1